



































































import { Vue, Component } from 'vue-property-decorator';
import { Swipe, SwipeItem, ImagePreview } from 'vant';
import Banner from '@/components/Banner.vue';
import { getDetail, cardMachine } from '../api';
import XGplayer from '@/components/XGplayer.vue';

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(ImagePreview);
@Component({
  name: 'Detail',
  components: {
    Banner,
    XGplayer,
  },
})
export default class Detail extends Vue {
  banner = require('../assets/mibaobaobanner.jpg');
  headList: any = {};
  detail: any = {};
  current = 0;
  created() {
    this.fetchData();
  }

  onChange(index: number) {
    this.current = index;
  }
  showImage(data: any, index: number) {
    ImagePreview({
      images: data,
      startPosition: index,
    });
  }

  async fetchData() {
    try {
      const res: any = await getDetail(this.$route.query.id as string);
      this.detail = res.data;
      const ret = await cardMachine();
      this.headList = ret.data;
    } catch (error) {
      console.log(error);
    }
  }

  goToMap(coordinate: string, address: string) {
    const url = 'https://api.map.baidu.com/marker?location=' + coordinate + '&title=我的位置&content=' + address + '&output=html&src=webapp.baidu.openAPIdemo';
    console.log(url);
    window.location.href = url;
  }
}
